<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">工资管理</span></div>
		<div class="salary-box">
            <Tabs :datas="tabsParam" class-name="h-tabs-card" v-model="tabsSelected" @change="tabsChange">
            </Tabs>
            <div class="salary-body h-panel-body">
                <div class="salaryList" v-show="tabsSelected=='tab1'">
                    <div class="topselectbox"  > 
                        <div class="topselect01"  >
                            <div class="depselect" style="width: 230px;display:flex;float:left;margin-left:15px;">
                                <span style="line-height:32px;">时间：</span>
                                <Select v-model="queryData.salaryMonth" :datas="dateSelectList" style="width:180px;" keyName="key" titleName="name" :change="selectMonth()"></Select>
                            </div>
                             <div class="depselect" style="width: 230px;display:flex;float:left;margin-left:15px;">
                                <span style="line-height:32px;">部门：</span>
                                <Select v-model="queryData.departId" :datas="departList" style="width:180px;" keyName="id" titleName="name"></Select>
                            </div>
                            <div class="depselect" style="width: 230px;display:flex;float:left;margin-left:15px;">
                                <span style="line-height:32px;">姓名：</span>
                                <input type="text" v-model="queryData.personName"/>
                            </div>
                            <div class="depselect" style="width: 230px;display:flex;float:left;margin-left:15px;">
                                <button class="h-btn h-btn-blue" @click="searchData()">查询</button>
                                <button class="h-btn h-btn-blue" @click="editData()">编辑</button>
                                <button class="h-btn h-btn-blue" @click="generateData()">生成工资表</button>
                            </div>
                        </div>
                        <div class="topselect02"> 
                            <div style="float:right"><button class="h-btn h-btn-blue" @click="showDrawer()">自定义工资项目</button>
									<button class="h-btn" @click="exportToExcel()">导出</button>
								</div> 
			            </div>
                    </div>
                    <div style="clear:both;height:15px;width:100%"></div>
                     <Table id="tb_salary" border :datas="datas" :columns="tableCols" checkbox :ths="tableTitles" :height="600" @select="onselect"  selectWhenClickTr > 
                        
                    </Table>
                </div>
                <div class="salaryExtract" v-show="tabsSelected=='tab2'">
                    <div class="topselectbox"  > 
                        <div class="topselect01"  >
                            <div class="depselect" style="width: 230px;display:flex;float:left;margin-left:15px;">
                                <span style="line-height:32px;">时间：</span>
                                <Select v-model="colSelectMonth" :datas="dateSelectList2" style="width:180px;" keyName="key" titleName="name" :change="selectMonth2()"></Select>
                            </div>
                        </div> 
                            <div style="clear:both;height:15px;width:100%"></div>
                            <div class="gongzibox"> 
                                <dl>
                                    <dt>计提工资</dt>
                                    <dd>{{ collectdata.jt }}</dd>
                                </dl>

                                <dl>
                                    <dt>发放工资</dt>
                                    <dd>{{ collectdata.ff }}</dd>
                                </dl>

                                <dl>
                                    <dt>分红</dt>
                                    <dd>{{ collectdata.fh }}</dd>
                                </dl>

                            </div>
                         
                    </div>
                </div>
                
                <a-drawer title="自定义工资项目" width="1200" :closable="false" :visible="visible" @close="onClose()">
                    <div class="customsalarybox"> 
                        <div class="xmlistbox"> 
                            <blockquote>工资总额</blockquote> 
                            <ul class="template_ul">
                                <li>
                                    <!-- <span v-if="templatelist.length > 0">
                                        <a-input style="width:150px" ref="userNameInput"  class="xmlistboxinput"
                                            v-for="(item, index) in templatelist[0].itemList" :value="item.name">
                                        </a-input>
                                    </span> -->
                                    <a-input style="width:150px" v-for="(item, index) in gzzearr" class="xmlistboxinput" :key="index" :value="item.name" @blur="onBlur($event,1,index)">
                                        <a-tooltip slot="suffix" title="删除" @click="removeinput(1, index)">
                                            <a-icon type="close" style="color: rgba(0,0,0,.45)" />
                                        </a-tooltip>
                                    </a-input>
                                    <a-button type="primary" class="xmlistbtn" @click="addinput(1)">添加列</a-button>
                                </li>
                            </ul>
                        </div>

                        <div class="xmlistbox"> 
                            <blockquote>应扣工资</blockquote>
                            <ul class="template_ul">
                                <li>
                                    <span v-if="templatelist.length > 1">
                                        <!-- <a-input style="width:150px" ref="userNameInput" class="xmlistboxinput"
                                            v-for="(item, index) in templatelist[1].itemList" :value="item.name">
                                        </a-input> -->
                                    
                                        <a-input style="width:150px"  v-for="(item, index) in ykgzarr" :key="index" :value="item.name" class="xmlistboxinput" ref="userNameInput" @blur="onBlur($event,2,index)">
                                            <a-tooltip slot="suffix" title="删除" @click="removeinput(2,index)">
                                                <a-icon type="close" style="color: rgba(0,0,0,.45)" />
                                            </a-tooltip>
                                        </a-input>
                                    </span>
                                    <a-button type="primary" class="xmlistbtn" @click="addinput(2)">添加列</a-button>
                                </li>
                            </ul>
                        </div> 
                        <div class="xmlistbox">
                            <blockquote>实发工资调整</blockquote>
                            <ul class="template_ul">
                                <li>
                                    <!-- <span v-if="templatelist.length > 2">
                                        <a-input style="width:150px" class="xmlistboxinput" ref="userNameInput" v-for="(item, index) in templatelist[2].itemList" :value="item.name">
                                        </a-input>
                                    </span> -->
                                    <a-input style="width:150px" class="xmlistboxinput" v-for="(item, index) in sfgztzarr" :key="index" :value="item.name" ref="userNameInput" @blur="onBlur($event,3,index)">
                                        <a-tooltip slot="suffix" title="删除" @click="removeinput(3,index)">
                                            <a-icon type="close" style="color: rgba(0,0,0,.45)" />
                                        </a-tooltip>
                                    </a-input>
                                    <a-button type="primary" class="xmlistbtn" @click="addinput(3)">添加列</a-button>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div :style="{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e8e8e8',
                        padding: '10px 16px',
                        textAlign: 'right',
                        left: 0,
                        background: '#fff',
                        borderRadius: '0 0 4px 4px',
                    }">
                        <a-button style="marginRight: 8px" @click="onClose()">
                            取消
                        </a-button>
                        <a-button type="primary" @click="onSaveTamplate()">
                            保存
                        </a-button>
                    </div>
                </a-drawer>
                <a-drawer title="编辑工资信息" width="1200" :closable="false" :visible="editVisible" @close="onEditClose()">
                     <div class="salary_table">
                        <h3>基本信息</h3> 
                        <table style="width:100%">
                            <tr>
                                <td width="33%">员工编号：{{selectedData.personCode}}</td>
                                <td width="33%">员工姓名：{{selectedData.personName}}</td>
                                <td width="33%">所属部门：{{selectedData.departName}}</td>
                            </tr>
                            <tr>
                                <td width="33%">手机号：{{selectedData.phone}}</td>
                                <td width="33%">身份证号：{{selectedData.cardNo}}</td> 
                            </tr>
                        </table>

                        <h3>工资总额</h3>  
                        <ul v-html="gzze_html"></ul> 

                        <h3>应扣工资</h3> 
                        <ul v-html="ykgz_html"></ul>

                        <h3>实发工资调整</h3>  
                        <ul v-html="sfgztz_html"></ul> 

                        <h3>工资及个税</h3> 
                        <table style="width:100%">
                            <tr>
                                <td width="33%">个税免征额：<a-input style="width:200px" v-model="selectedData.freeTaxSalary"  /></td>
                                <td width="33%">应发工资：<a-input style="width:200px" v-model="selectedData.beforeSalaryAmount"  /></td>
                                <td width="33%">其他扣除：<a-input style="width:200px" v-model="selectedData.otherAeductAmount"  /></td>
                            </tr>
                            <tr>
                                <td width="33%">累计收入额：<a-input style="width:200px" v-model="selectedData.sumIncomeAmount"  /></td>
                                <td width="33%">累计减除费用：<a-input style="width:200px" v-model="selectedData.sumReduceAmount"  /></td> 
                                <td width="33%">累计代扣额：<a-input style="width:200px" v-model="selectedData.sumWithholdAmount"  /></td> 
                            </tr>
                            <tr>
                                <td width="33%">累计应缴个税：<a-input style="width:200px" v-model="selectedData.sumPersonTax"  /></td>
                                <td width="33%">已缴个税：<a-input style="width:200px" v-model="selectedData.alreadyPersonTax"  /></td> 
                                <td width="33%">本月应缴个税：<a-input style="width:200px" v-model="selectedData.theMonthPersonTax"  /></td> 
                            </tr>
                            <tr>
                                <td width="33%">个税调整：<a-input style="width:200px" v-model="selectedData.taxReset"  /></td>
                                <td width="33%">累计其他扣除：<a-input style="width:200px" v-model="selectedData.sumOtherDeductAmount"  /></td> 
                                <td width="33%">实发工资：<a-input style="width:200px" v-model="selectedData.afterSalary"  /></td> 
                            </tr>
                        </table>

                        <h3>专项附加扣除</h3> 
                        <table style="width:100%">
                            <tr>
                                <td width="33%">子女教育：<a-input style="width:200px" v-model="selectedData.education"  /></td>
                                <td width="33%">赡养老人：<a-input style="width:200px" v-model="selectedData.elderly"  /></td>
                                <td width="33%">住房贷款利息：<a-input style="width:200px" v-model="selectedData.loanInterest"  /></td>
                            </tr>
                            <tr>
                                <td width="33%">住房租金：<a-input style="width:200px" v-model="selectedData.rent"  /></td>
                                <td width="33%">继续教育：<a-input style="width:200px" v-model="selectedData.conElderly"  /></td> 
                                <td width="33%">3岁以下婴幼儿照护：<a-input style="width:200px" v-model="selectedData.babyCare"  /></td> 
                            </tr>
                            
                        </table>

                        <h3>代扣个人款项</h3> 
                        <ul v-html="personInsure_html"></ul> 

                        <h3>公司承担款项</h3> 
                        <ul v-html="companyInsure_html"></ul> 
                        <br/>
                        <table style="width:100%;">
                            <tr>
                                <td width="33%">成本合计：<a-input style="width:200px" v-model="selectedData.sumCost"  /></td> 
                            </tr> 
                        </table> 
                     </div>
                     <!-- position: 'absolute', -->
                     <div :style="{bottom: 0,width: '100%',borderTop: '1px solid #e8e8e8',
                        padding: '10px 16px',textAlign: 'right',left: 0,background: '#fff',borderRadius: '0 0 4px 4px',}">

                            <a-button style="marginRight: 8px" @click="onEditClose()">取消</a-button>
                            <a-button type="primary" @click="onSaveEdit()">保存</a-button>
                    </div>
                </a-drawer>
            </div>
            
        </div>
	</app-content>
</template>

<script>
	const emptyForm = {
		"code": "",
		"name": "",
		"exchangeRate": "",
	};


import { mapState } from 'vuex';
import { saveAs } from 'file-saver';
// import xlsx from 'xlsx';
import * as XLSX from 'xlsx';
	export default {
		name: 'Currency',
		data() {
			return {
				datas: [],
                visible:false,
                editVisible:false,
				form: Object.assign({}, emptyForm),
				tabsParam:{
                    tab1:'工资列表',
                    tab2:'计提工资，发放工资'
                },
                tabsSelected:'tab1',
                tableTitles:[],
                tableCols:[],
				showForm: false,
				loading: false,
                dateList:[],
                dateSelectList:[], 
                dateSelectList2:[],
                departList:[],
                queryData:{
                    salaryMonth:undefined,
                    departId:undefined,
                    personName:''
                }, 
                year:undefined,
                month:undefined,
                gzsize:1,
                kksize:1,
                tzsize:1,
                defaultInsureList:[],
                personInsureSize:1,
                companyInsureSize:1,    
                colSelectMonth:undefined,
                colYear:undefined,
                colMonth:undefined,
                collectdata: {}, //计提工资    
                templatelist:[], 
                gzzearr:[], 
                ykgzarr:[],
                sfgztzarr:[], 
                selectedData:{},    
                selectedLength:0,
                gzze_html:"",
                ykgz_html:"",
                sfgztz_html:"", 
                gzzelist:[],
                ykgzlist:[],
                sfgztzlist:[],
                companyInsure_html:"",
                personInsure_html:"",
                editInsureList:[],
			};  
		},
		watch: {
			showForm(val) {
				if (!val) {
					this.reset();
				}
			}
		},
        computed: {
            ...mapState(['User', 'currentAccountSets']),
        },
		methods: {
			loadList() { 
                var that = this;
                this.gzsize=3;
  
                //获取时间
                this.$api.wages.salarydateList(this.User.accountSetsId).then(({data}) => {
                    this.dateList=data;
                    this.defaultYearMonth();
                    
                    //获取自定义模板
                    var tparms = {
                        "accountSetsId":this.User.accountSetsId,
                        "year":this.year,
                        "month":this.month
                    };
                    this.$api.wages.gettemplate(tparms).then((res) => {
                        // console.log(res)
                        if(res.code == 200){
                            var templates = res.data;
                            var gzlist = new Array();
                            var kklist = new Array();
                            var tzlist = new Array();
                            var colsArr =  new Array();
                            var tzColArr =[];
                            var tbCols=[];
                            that.tableCols=[{ width:60 ,height:20,prop:'personCode'  },
                                            { width:200 ,height:20,prop:'personName' },
                                            { width:100 ,height:20,prop:'departName'},
                                            { width:100 ,height:20,prop:'phone'},
                                            { width:150 ,height:20,prop:'cardNo'},
                                            { width:100 ,height:20,prop:'freeTaxSalary'}];
                            for(var i = 0; i<templates.length;i++){  
                                if(templates[i].type == 1){ 
                                    gzlist = templates[i]; 
                                    that.gzsize = gzlist.itemList.length; 
                                    for(var j = 0;j<templates[i].itemList.length;j++){
                                        colsArr.push({'title':templates[i].itemList[j].name,'prop':'income'+(j+1)});
                                        that.tableCols.push({ 'prop':'income'+(j+1),width:'100',height:20})
                                    }
                                }else if(templates[i].type == 2){
                                    kklist = templates[i];
                                    that.kksize = kklist.itemList.length;  
                                    for(var j = 0;j<templates[i].itemList.length;j++){
                                        colsArr.push({'title':templates[i].itemList[j].name,'prop':'reduce'+(j+1)});
                                        that.tableCols.push({ 'prop':'reduce'+(j+1),width:'100',height:20})
                                    }
                                }else if(templates[i].type == 3){
                                    tzlist = templates[i];
                                    that.tzsize = tzlist.itemList.length;  
                                    for(var j = 0;j<templates[i].itemList.length;j++){
                                        tzColArr.push({'title':templates[i].itemList[j].name,'prop':'adjust'+(j+1)});
                                        tbCols.push({ 'prop':'adjust'+(j+1),width:'100',height:20})
                                    }
                                } 

                            } 
                              
                            //获取账套五险一金信息
                            var insureParams = {
                                accountSetsId:that.User.accountSetsId,
                                personId: '-1'
                            }
                            this.$api.wages.insureList(insureParams).then((insureRes) => {
                                if(insureRes.code==200){
                                    that.defaultInsureList=insureRes.data;
                                    // console.log(that.defaultInsureList)
                                    if(that.defaultInsureList!=undefined && that.defaultInsureList.length>0){
                                        that.personInsureSize = that.defaultInsureList.length;
                                        that.companyInsureSize = that.defaultInsureList.length;
                                        that.tableCols.push({ width:80 ,height:20,prop:'beforeSalaryAmount'});
                                        //代扣个人款项 
                                        for(var p =0;p<that.defaultInsureList.length;p++){
                                            colsArr.push({'title':that.defaultInsureList[p].itemName,prop:'pInsure'+that.defaultInsureList[p].itemName});
                                            that.tableCols.push({prop:'pInsure'+that.defaultInsureList[p].itemName,width:'80',height:20});
                                        }
                                        
                                        that.tableCols.push({ width:80 ,height:20,prop:'otherAeductAmount'});
                                        that.tableCols.push( { width:80 ,height:20,prop:'sumIncomeAmount'});
                                        that.tableCols.push({ width:100 ,height:20,prop:'sumReduceAmount'});
                                        that.tableCols.push({ width:80 ,height:20,prop:'sumWithholdAmount'});

                                        //累计专项附加扣除 
                                        colsArr.push({'title':'子女教育',prop:'education','width':80})
                                        colsArr.push({'title':'赡养老人',prop:'elderly'})
                                        colsArr.push({'title':'住房贷款利息',prop:'loanInterest'})
                                        colsArr.push({'title':'住房租金',prop:'rent'})
                                        colsArr.push({'title':'继续教育',prop:'conElderly'})
                                        colsArr.push({'title':'3岁以下婴幼儿照护',prop:'babyCare'})
                                        colsArr.push({'title':'累计专项附加扣除小计',prop:'additionalSumAmount'})
  
                                        that.tableCols.push({prop:'education','width':80,height:20})
                                        that.tableCols.push({prop:'elderly','width':80,height:20})
                                        that.tableCols.push({prop:'loanInterest','width':100,height:20})
                                        that.tableCols.push({prop:'rent','width':80,height:20})
                                        that.tableCols.push({prop:'conElderly','width':80,height:20})
                                        that.tableCols.push({prop:'babyCare','width':80,height:20})
                                        that.tableCols.push({prop:'additionalSumAmount','width':80,height:20})

                                        that.tableCols.push({prop:'sumOtherDeductAmount','width':80,height:20})
                                        that.tableCols.push({prop:'sumPersonTax','width':80,height:20})
                                        that.tableCols.push({prop:'alreadyPersonTax','width':80,height:20})
                                        that.tableCols.push({prop:'theMonthPersonTax','width':80,height:20})
                                        that.tableCols.push({prop:'taxReset','width':80,height:20}) 
                                      
                                        //实发工资调整
                                        // colsArr.push(tzColArr);
                                        for(var tzc=0;tzc<tzColArr.length;tzc++){
                                            colsArr.push({'title':tzColArr[tzc].title,'prop':tzColArr[tzc].prop});
                                            that.tableCols.push({'prop':tzColArr[tzc].prop,'width':80,height:20});
                                        }
                                        that.tableCols.push({prop:'afterSalary','width':80,height:20})  
                                        //公司承担款项
                                        for(var p =0;p<that.defaultInsureList.length;p++){
                                            colsArr.push({'title':that.defaultInsureList[p].itemName,prop:'cInsure'+that.defaultInsureList[p].itemName});
                                            that.tableCols.push({prop:'cInsure'+that.defaultInsureList[p].itemName,'width':80,height:20});
                                        }
                                        that.tableCols.push({ width:80 ,height:20,prop:'sumCost',className:'tb_col'});
                                        

                                        that.tableTitles=[[
                                            { title: '编号', rowspan: 2,prop:'personCode' },
                                            { title: '姓名', rowspan: 2 ,prop:'personName' },
                                            { title: '部门', rowspan: 2 ,prop:'departName'},
                                            { title: '手机号', rowspan: 2 ,prop:'phone'},
                                            { title: '身份证号码', rowspan: 2 ,prop:'cardNo'},
                                            { title: '个税免征额', rowspan: 2 ,prop:'freeTaxSalary'},
                                            { title: '工资总额',colspan:that.gzsize},
                                            { title: '应扣工资',colspan:that.kksize},
                                            { title: '应发工资', rowspan: 2 ,prop:'beforeSalaryAmount'},
                                            { title: '代扣个人款项',colspan:that.personInsureSize},
                                            { title: '其他扣除', rowspan: 2 ,prop:'otherAeductAmount'},
                                            { title: '累计收入额', rowspan: 2 ,prop:'sumIncomeAmount'},
                                            { title: '累计减除费用', rowspan: 2 ,prop:'sumReduceAmount'},
                                            { title: '累计代扣额', rowspan: 2 ,prop:'sumWithholdAmount'},
                                            { title: '累计专项附加扣除',colspan:7},
                                            { title: '累计其他扣除', rowspan: 2 ,prop:'sumOtherDeductAmount'},
                                            { title: '累计应缴个税', rowspan: 2 ,prop:'sumPersonTax'},
                                            { title: '已缴个税', rowspan: 2 ,prop:'alreadyPersonTax'},
                                            { title: '本月应缴个税', rowspan: 2 ,prop:'theMonthPersonTax'},
                                            { title: '个税调整', rowspan: 2 ,prop:'taxReset'},
                                            { title: '实发工资调整',colspan:that.tzsize},
                                            { title: '实发工资',rowspan: 2 ,prop:'afterSalary'},
                                            { title: '公司承担款项',colspan:that.companyInsureSize},
                                            { title: '员工成本合计',rowspan: 2 ,prop:'sumCost'}
                                        ]];
                                        that.tableTitles[1]=colsArr;  
                                        console.log(that.tableTitles[1]);
                                        console.log(that.tableCols)
                                        console.log('加载完成了哦！！！！')
                                        this.listData();
                                        
                                    }
                                }
                                
                            }) 
                            
                            
                        }
                    });
                })
                
                 
			},
            listData(){
                var that= this;
                var listParams={
                    current:1,
                    size:99,
                    isComplex:1,
                    accountSetsId:that.User.accountSetsId,
                    year:that.year,
                    month:that.month,
                    departId:that.queryData.departId,
                    personName:that.queryData.personName
                }; 
                var dataarr = [];
                this.$api.wages.salarylist(listParams).then(listRes => {
                    if (listRes.code == 200) { 
                        listRes.data.records.forEach(element => {
                            dataarr.push(element.salaryInfo);
                        });
                        that.datas = dataarr;  
                    }
                })
            },
            searchData(){
                this.listData();
            },
            //标签页点击
            tabsChange(data){
                if(data.key=='tab1'){
                    // console.log('工资列表')
                }
                else if(data.key=='tab2'){
                    // console.log('计提工资')
                    this.getcollectsalary();
                }
            },
			submit() {
				 
			},
			reset() {
				this.form = Object.assign({}, emptyForm)
			},
			remove(data) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.setting.currency.delete(data.id).then(() => {
						this.loadList();
					})
				})
			},
			edit(data) {
				this.form = Object.assign({}, data)
				this.showForm = true;
			},
			checkCode() {
				this.$set(this.form, 'code', this.form.code.toUpperCase());
			},
            //时间组件初始化
            defaultYearMonth(){
                this.dateSelectList= new Array();
                this.dateSelectList2= new Array();
                var datelistarr = new Array(); 
                for (var i = 0; i < this.dateList.length; i++) {
                    var str = this.dateList[i];
                    var arr = str.match(/\d+/g);
                    datelistarr.push(arr);
                    this.dateSelectList.push({key:i,name:this.dateList[i]});
                    this.dateSelectList2.push({key:i,name:this.dateList[i]});
                }; 
                this.queryData.salaryMonth = this.dateSelectList[this.dateSelectList.length-1].key; 
                this.colSelectMonth = this.dateSelectList2[this.dateSelectList2.length-1].key;
                
                this.year = datelistarr.slice(-1)[0][0]; 
                this.month = datelistarr.slice(-1)[0][1];
                this.colYear=datelistarr.slice(-1)[0][0]; 
                this.colMonth =datelistarr.slice(-1)[0][1]; 

                //获取模板数据
                this.getTemplate();
            },
            //选中时间
            selectMonth(){ 
                if(this.queryData.salaryMonth!=undefined ){
                    var str =this.dateSelectList[this.queryData.salaryMonth].name;
                  
                    var arr = str.match(/\d+/g);
                    this.year=arr[0];
                    this.month =arr[1];
                }
                // this.listData();
                 
            },
            //选中时间
            selectMonth2(){  
                if(this.colSelectMonth!=undefined ){
                    var str =this.dateSelectList[this.colSelectMonth].name;
                    var arr = str.match(/\d+/g);
                    if(!(arr[0]==this.colYear) || !(arr[1]==this.colMonth)){
                        this.colYear=arr[0];
                        this.colMonth =arr[1];
                        //查询计提工资数据
                        this.getcollectsalary();
                    }
                    
                    
                }
            },
            //获取部门列表
            getDepartList(){
                var accountSetsId= this.User.accountSetsId;
                this.$api.wages.department(accountSetsId).then(res => {
                    if(res.code==200){
                        this.departList=res.data;
                    }
                });
            },
            //获取工资统计项
            getcollectsalary() { 
                var params = {
                    accountSetsId: this.User.accountSetsId,
                    year:this.colYear,
                    month:this.colMonth
                };
                this.$api.wages.getcollect(params).then(data => {
                    if (data.code == 200) {
                        this.collectdata = data.data;
                    }
                });
            },
            //自定义模板
            showDrawer() { 
                this.getTemplate();
                
                this.visible = true; 
            },
            getTemplate(){ 
                var params = {
                    accountSetsId: this.User.accountSetsId,
                    year:this.year,
                    month:this.month
                };
                this.$api.wages.gettemplate(params).then(data => { 
                    if (data.code == 200) {
                        this.templatelist = data.data; 
                        this.gzzearr=this.templatelist[0].itemList;
                        this.ykgzarr=this.templatelist[1].itemList;
                        this.sfgztzarr=this.templatelist[2].itemList;
                    }
                }); 
            },
            addinput(type) { 
                if(type==1){ 
                    var index = this.gzzearr.length;
                    this.gzzearr.push({'key':index,'name':''});
                }
                if(type==2){ 
                    var index = this.ykgzarr.length;
                    this.ykgzarr.push({'key':index,'name':''});
                }
                if(type==3){ 
                    var index = this.sfgztzarr.length;
                    this.sfgztzarr.push({'key':index,'name':''});
                }

            },
            removeinput(e, index) {

                if(e==1){  
                    this.gzzearr.splice(index, 1);
                    console.log(this.gzzearr)
                }
                if(e==2){ 
                  this.ykgzarr.splice(index, 1);
                }
                if(e==3){ 
                    this.sfgztzarr.splice(index, 1); 
                } 

            },
            onClose() {
                this.visible = false;
            },
            //保存模版信息
            onSaveTamplate(){
                let arr1 =new Array();  
                this.gzzearr.forEach(e => {
                    if(e.name!=undefined&& e.name.trim()!=''){
                        arr1.push({'name':e.name});
                    }
                }); 
                var ykgzarr1 = new Array();  
                this.ykgzarr.forEach(e => {
                    if(e.name!=undefined&& e.name.trim()!=''){
                        ykgzarr1.push({'name':e.name});
                    }
                });
                var sfgztzarr1 = new Array(); 
                this.sfgztzarr.forEach(e => {
                    if(e.name!=undefined&& e.name.trim()!=''){
                        sfgztzarr1.push({'name':e.name});
                    }
                });
                var params=[
                    {
                        accountSetsId:this.User.accountSetsId,
                        type:1,
                        year:this.year,
                        month:this.month,
                        itemList:arr1
                    },
                    {
                        accountSetsId:this.User.accountSetsId,
                        type:2,
                        year:this.year,
                        month:this.month,
                        itemList:ykgzarr1
                    },
                    {
                        accountSetsId:this.User.accountSetsId,
                        type:3,
                        year:this.year,
                        month:this.month,
                        itemList:sfgztzarr1
                    }
                ]; 
                 this.$api.wages.savetemplate(params).then(data => { 
                    // console.log(data)
                    if (data.code == 200) {
                        this.$message.success('编辑成功');
                        this.visible = false;
                    }else{
                        this.$message.error('编辑失败');
                    }
                }); 
                
            }, 
            onBlur(event,type,index){
                var inputVal =event.target.value;
                 if(type==1){  
                    this.gzzearr[index].name=inputVal;
                }
                if(type==2){ 
                    this.ykgzarr[index].name=inputVal; 
                }
                if(type==3){ 
                    this.sfgztzarr[index].name=inputVal; 
                } 
            } ,
            // rowClick(data, event, index){
            //     console.log(data);
            //     console.log(event);
            //     console.log(index);
            // },
            //选中行
            onselect(data, event){
                if(data.length==1){
                    this.selectedData =data[0];
                }else{
                    this.selectedData ={};
                }
                this.selectedLength=data.length;
            },
            //生成工资表
            generateData(){
                var params={
                    accountSetsId:this.User.accountSetsId,
                    year:this.year,
                    month:this.month
                };
                this.$api.wages.generateData(params).then(data => {
                    if(data.code==200){
                        this.$message.success('生成成功');
                        this.listData();
                    }else{
                        this.$message.error(data.msg);
                    }
                });
              
            },
            //编辑
            editData(){
                var that=this;
                if(this.selectedLength>1|| this.selectedLength==0){
                    this.$message.error('请选中一行数据');
                }else{
                    console.log(this.selectedData)
                    var params={
                        accountSetsId:this.selectedData.accountSetsId,
                        year:this.selectedData.year,
                        month:this.selectedData.month,
                        personId:this.selectedData.personId
                    };
                    var gzzeHtml="";
                    var ykgzHtml="";
                    var sfgztzHtml="";
                    var piHtml="";
                    var ciHtml="";
                    this.$api.wages.salaryDetails(params).then(res => {
                        if(res.code==200){
                            that.gzzelist = res.data.income.itemList;
                            that.ykgzlist =res.data.reduce.itemList;
                            that.sfgztzlist = res.data.adjust.itemList;
                            if(that.gzzelist!=undefined&& that.gzzelist.length>0){
                                for(var i=0;i<that.gzzelist.length;i++){
                                    gzzeHtml=gzzeHtml+"<li style='float:left;height:35px;width:33%;'><span>"+that.gzzelist[i].name+"：</span><input id='input_gzze_"+i+"' class='ant-input' value='"+that.gzzelist[i].amount+"' style='width:200px'/></li>";
                                };
                            } 
                            this.gzze_html=gzzeHtml;
                            if(that.ykgzlist!=undefined&& that.ykgzlist.length>0){
                                for(var i=0;i<that.ykgzlist.length;i++){
                                    ykgzHtml=ykgzHtml+"<li style='float:left;height:35px;width:33%;'><span>"+that.ykgzlist[i].name+"：</span><input id='input_ykgz_"+i+"' class='ant-input' value='"+that.ykgzlist[i].amount+"' style='width:200px'/></li>";
                                };
                            } 
                            this.ykgz_html=ykgzHtml;

                            if(that.sfgztzlist!=undefined&& that.sfgztzlist.length>0){
                                for(var i=0;i<that.sfgztzlist.length;i++){
                                    sfgztzHtml=sfgztzHtml+"<li style='float:left;height:35px;width:33%;'><span>"+that.sfgztzlist[i].name+"：</span><input id='input_sfgztz_"+i+"' class='ant-input' value='"+that.sfgztzlist[i].amount+"' style='width:200px'/></li>";
                                };
                            } 
                            this.sfgztz_html=sfgztzHtml;


                            //五险一金
                            that.editInsureList =res.data.personInsureList;
                            if(res.data.personInsureList!=undefined && res.data.personInsureList.length>0){
                                for(var i=0;i<that.editInsureList.length;i++){
                                    piHtml=piHtml+"<li style='float:left;height:35px;width:33%;'><span>"+that.editInsureList[i].itemName+"：</span><input id='input_personInsure_"+i+"' class='ant-input' value='"+that.editInsureList[i].personPayment+"' style='width:200px'/></li>";
                                    ciHtml=ciHtml+"<li style='float:left;height:35px;width:33%;'><span>"+that.editInsureList[i].itemName+"：</span><input id='input_companyInsure_"+i+"' class='ant-input' value='"+that.editInsureList[i].companyPayment+"' style='width:200px'/></li>";
                                }
                                that.personInsure_html=piHtml;
                                that.companyInsure_html=ciHtml;
                            }
                        }
                    });
                    
                    //弹出编辑框
                    this.editVisible=true;
                }
            },
            onSaveEdit(){

                //保存工资信息
                var params = {};
                params.salaryInfo=this.selectedData;
                //工资总额
                if(this.gzzelist!=undefined && this.gzzelist.length>0){
                    for(var i =0; i<this.gzzelist.length;i++){
                        var item=document.getElementById("input_gzze_"+i);
                        this.gzzelist[i].amount=item==undefined?0:item.value;
                    } 
                }
                params.income ={
                            'salaryId':params.salaryInfo.id,
                            'itemList':this.gzzelist
                        }
                    
                //应扣工资
                if(this.ykgzlist!=undefined && this.ykgzlist.length>0){
                    for(var i =0; i<this.ykgzlist.length;i++){
                        var item=document.getElementById("input_ykgz_"+i);
                        this.ykgzlist[i].amount=item==undefined?0:item.value;
                    } 
                }
                params.reduce={
                            'salaryId':params.salaryInfo.id,
                            'itemList':this.ykgzlist
                        };
                    
                //实发工资调整
                if(this.sfgztzlist!=undefined && this.sfgztzlist.length>0){
                    for(var i =0; i<this.sfgztzlist.length;i++){
                        var item=document.getElementById("input_sfgztz_"+i);
                        this.sfgztzlist[i].amount=item==undefined?0:item.value;
                    } 
                }
                params.adjust={
                            'salaryId':params.salaryInfo.id,
                            'itemList':this.sfgztzlist
                        };
                //五险一金
                var insureList=new Array();
                if(this.editInsureList!=undefined && this.editInsureList.length>0){
                    for(var i =0; i<this.editInsureList.length;i++){
                        var pitem=document.getElementById("input_personInsure_"+i);
                        var citem=document.getElementById("input_companyInsure_"+i);
                        var ii = {};
                        ii.accountSetsId = params.salaryInfo.accountSetsId;
                        ii.personId= params.salaryInfo.personId;
                        ii.itemName = this.editInsureList[i].itemName;
                        ii.companyRate = this.editInsureList[i].companyRate;
                        ii.personRate = this.editInsureList[i].personRate;
                        ii.paymentBase = this.editInsureList[i].paymentBase;
                        ii.companyPayment = citem==undefined?0:citem.value;
                        ii.personPayment = pitem==undefined?0:pitem.value;
                        insureList.push(ii);
                    } 
                }
                params.personInsureList=insureList;


                /** 计算工资成本和个人所得税 
                //工资总额
                var calcSalaryObj=this.selectedData;
                var gzze = 0;
                for(var i=0;i<params.income.itemList.length;i++){
                    gzze += parseInt(params.income.itemList[i].amount);
                }
                //应扣工资总额
                var ykgzze = 0;
                for(var i=0;i<params.reduce.itemList.length;i++){
                    ykgzze += parseInt(params.reduce.itemList[i].amount);
                }
                //专项附加扣除小计
                var sumZxfj = (calcSalaryObj.rent!=undefined && calcSalaryObj.rent != '' ? parseInt(calcSalaryObj.rent):0) +
                (calcSalaryObj.conElderly!=undefined && calcSalaryObj.conElderly != '' ? parseInt(calcSalaryObj.conElderly):0) +
                (calcSalaryObj.babyCare!=undefined && calcSalaryObj.babyCare != '' ? parseInt(calcSalaryObj.babyCare):0) +
                (calcSalaryObj.loanInterest!=undefined && calcSalaryObj.loanInterest != '' ? parseInt(calcSalaryObj.loanInterest):0) +
                (calcSalaryObj.elderly!=undefined && calcSalaryObj.elderly != '' ? parseInt(calcSalaryObj.elderly):0) +
                (calcSalaryObj.education!=undefined && calcSalaryObj.education != '' ? parseInt(calcSalaryObj.education):0);
                calcSalaryObj.additionalSumAmount =  sumZxfj;

                //五险一金
                //个人代扣款项
                var sumPersonPayment=0;
                //公司负责款项小计
                var sumCompayPayment=0;
                if(insureList!=undefined && insureList.length>0){
                    for(var i=0;i<insureList.length;i++){
                        //个人代扣款项小计
                        sumPersonPayment += (insureList[i].personPayment!=undefined && insureList[i].personPayment != '' ? parseInt(insureList[i].personPayment):0) ;
                        //公司负责款项小计
                        sumCompayPayment += (insureList[i].companyPayment!=undefined && insureList[i].companyPayment != '' ? parseInt(insureList[i].companyPayment):0) ;
                    }
                }

                //应付工资 = 工资总额 - 应扣工资总额
                calcSalaryObj.beforeSalaryAmount = gzze - ykgzze;
                this.editVisible=false;
                */

  
                console.log(params);

                this.$api.wages.salaryUpdate(params).then(res => {
                    if(res.code==200){
                        this.$message.success('编辑成功');
                        this.editVisible=false;
                        this.listData();
                    }else {
						this.$message.error('编辑失败');
					}
                });

            },
            onEditClose(){
                this.editVisible=false;
            },
            //导出数据
            exportToExcel(){ 
                // 通过id获取表格DOM元素
                const table = document.querySelector('#tb_salary');
                // 将表格元素转换为<table>元素的工作表
                const ws = XLSX.utils.table_to_sheet(table);
                // 创建工作簿并添加工作表
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
                // 生成Excel文件并导出
                const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
                saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), '工资表.xlsx');
            },
            // 将字符串转换为ArrayBuffer
            s2ab(s) {
                const buf = new ArrayBuffer(s.length);
                const view = new Uint8Array(buf);
                for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                return buf;
            }


		}, 

		mounted() { 
            this.loadList();
            this.getDepartList();   
		},
        activated(){
            
        },
        created(){
            
        }
	};
</script>
<style lang="less" scoped>
.salary-box{
    width: 100%;
    margin-top: 20px;
}

// .gongzibox {
// 	padding-top: 20px;
// }

.gongzibox dl {
	border: 1px solid #eee;
	width: 250px;
	float: left;
	text-align: center;
	margin-right: 20px;
}

.gongzibox dl dt {
	border-bottom: 1px solid #eee;
	font-size: 16px;
	padding: 20px 0;
}

.gongzibox dl dd {
	padding: 20px 0;
	font-size: 18px;
	color: #2d7bf4
}
.xmlistbox{
    clear: both;
}
.xmlistboxinput{
    margin-left:8px;
    margin-top:5px;
    float: left;
}
 .xmlistbtn{
    margin-left:8px;
    margin-top:5px;
    clear: both;
 }
 .template_ul{
    margin:8px 2px;
 }
 .salary_tr{
    cursor:pointer,

 }
 .salary_tr:hover{
    content:"点击编辑"
 }
 .h-table-tr-hovered{
    background-color: aquamarine;
 }
 .salary_table{
    overflow:auto;
 }
 .salary_table table{
    width:100%;
    margin-bottom: 20px;
 }
 .salary_table table tr td{
    padding-left: 15px;
    height:35px;
    line-height: 30px;;
 }
 .salary_table ul{
    width:100%;
    padding-top:10px;
    padding-bottom: 10px;
    padding-left: 15px;
    margin-bottom: 40px;
 }
 
 .salary_table h3{
    font-weight: bold;
    clear: both;
 } 
 .salary_table ul li span{
    width:150px;
   }
</style>
